import { formatEther, parseEther } from 'ethers/lib/utils';
import React, { useState } from 'react'
import Button from './components/Button';
import { useCoinPrice, useContract, useImagePrice, useVideoPrice } from './web3/useContract';
import { PlusSmIcon, MinusSmIcon } from '@heroicons/react/solid'
import TransactionFlowModal from './components/TransactionFlowModal';
import { CrossmintPayButton } from "@crossmint/client-sdk-react-ui";

function App() {
  const {
    address,
    isConnected,
    saleActive,
    maxSupply,
    totalSupply,
    wethAllowance,
    wethBalance,
    remainingSupply,
    maxMintCount,
    confirmingTransaction,
    lastTransactionHash,
    contractError,
    connectWallet,
    buyImage,
    buyVideo,
    buyCoin,
    approveWETH
  } = useContract()

  const [showImageModal, setShowImageModal] = useState(false)
  const [showVideoModal, setShowVideoModal] = useState(false)
  const [showCoinModal, setShowCoinModal] = useState(false)
  const [desiredCount, setDesiredCount] = useState(1)

  const { price: imagePrice, maticPrice: imageMaticPrice } = useImagePrice(desiredCount)
  const { price: videoPrice, maticPrice: videoMaticPrice } = useVideoPrice(desiredCount)
  const { price: coinPrice, maticPrice: coinMaticPrice } = useCoinPrice(desiredCount)

  function increment() {
    setDesiredCount(Math.min(desiredCount + 1, maxMintCount))
  }

  function decrement() {
    setDesiredCount(Math.max(desiredCount - 1, 1))
  }

  return (
    <div className="max-w-3xl mx-auto min-h-screen mt-20">
      <div className='flex gap-4 items-center flex-col md:flex-row'>
        <div className='md:w-2/5 flex justify-center'>
          <Button disabled={isConnected} onClick={connectWallet}>
            Connect Wallet
          </Button>
        </div>
        <div className='md:w-3/5 text-xl'>
          { isConnected ? (
            <div className='flex flex-col gap-4'>
              <div>
                Address: { address }
              </div>
              <div>
                WETH Balance: { formatEther(wethBalance) }
              </div>
            </div>
          ) : (
            <div>
              Wallet: Not Connected
            </div>
          )}
        </div>
      </div>

      <div className='flex justify-center mt-20 items-center gap-8'>
        <span className='text-3xl'>
          {totalSupply} / {maxSupply} Minted
        </span>
      </div>

      <div className='flex justify-center mt-10 items-center gap-8'>
        <Button variant='round' onClick={decrement}>
          <MinusSmIcon className="h-6 w-6" aria-hidden="true" />
        </Button>

        <span className='text-3xl'>
          {desiredCount}
        </span>

        <Button variant='round' onClick={increment}>
          <PlusSmIcon className="h-6 w-6" aria-hidden="true" />
        </Button>
      </div>

      { contractError &&
        <div className='text-red-500 text-xl mt-10 text-center'>
          { contractError }
        </div>
      }

      <div className='flex justify-center mt-10 items-start md:items-center gap-8 md:flex-row flex-col'>
        <div className='flex flex-col gap-4 items-center md:w-1/3'>
          <span className='uppercase'>Still Image</span>

          <Button
            className="w-full"
            disabled={!isConnected}
            onClick={() => setShowImageModal(true)}
          >
            Buy with WETH for {formatEther(imagePrice)}
          </Button>

          <CrossmintPayButton
              collectionTitle="Beyond Street Cred NFT Film: Still Image"
              collectionDescription="1 of 6 Beyond Street Cred Still Image NFTs will be randomly distributed to you through this purchase."
              collectionPhoto="https://secureservercdn.net/198.71.233.167/q76.b7d.myftpupload.com/wp-content/uploads/2021/11/BSC-Logo3.png"
              clientId="2b5792de-bf7e-4a63-ab30-ee6090c66ad4"
              mintConfig={{
                  type: "erc-721",
                  price: formatEther(imageMaticPrice),
                  amount: desiredCount,
                }}
          />

          <TransactionFlowModal
            price={imagePrice}
            desiredCount={desiredCount}
            executeFn={buyImage}
            wethAllowance={wethAllowance}
            approveWETHFn={approveWETH}
            open={showImageModal}
            onClose={() => setShowImageModal(false)}
          />
        </div>
        <div className='flex flex-col gap-4 items-center md:w-1/3'>
          <span className='uppercase'>Video NFT</span>

          <Button
            className="w-full"
            disabled={!isConnected}
            onClick={() => setShowVideoModal(true)}
          >
            Buy with WETH for {formatEther(videoPrice)}
          </Button>

          {/* <CrossmintPayButton
              collectionTitle="Beyond Street Cred NFT Film: Video NFT"
              collectionDescription="1 of 3 Beyond Street Cred Video Collector's Card NFTs will be randomly distributed to you through this purchase."
              collectionPhoto="https://secureservercdn.net/198.71.233.167/q76.b7d.myftpupload.com/wp-content/uploads/2021/11/BSC-Logo3.png"
              clientId="2b5792de-bf7e-4a63-ab30-ee6090c66ad5"
              mintConfig={{
                  type: "erc-721",
                  price: formatEther(videoMaticPrice),
                  amount: desiredCount,
                }}
          /> */}

          <TransactionFlowModal
            price={videoPrice}
            desiredCount={desiredCount}
            executeFn={buyVideo}
            wethAllowance={wethAllowance}
            approveWETHFn={approveWETH}
            open={showVideoModal}
            onClose={() => setShowVideoModal(false)}
          />
        </div>
        <div className='flex flex-col gap-4 items-center md:w-1/3'>
          <span className='uppercase'>Super Street Cred Coin</span>

          <Button
            className="w-full"
            disabled={!isConnected}
            onClick={() => setShowCoinModal(true)}
          >
            Buy with WETH for {formatEther(coinPrice)}
          </Button>

          {/* <CrossmintPayButton
              collectionTitle="Beyond Street Cred NFT Film: Super Street Cred Coin"
              collectionDescription="A one of a kind Video NFT with the highest rarity granting top status amongst the series and a special thanks in the film credits."
              collectionPhoto="https://secureservercdn.net/198.71.233.167/q76.b7d.myftpupload.com/wp-content/uploads/2021/11/BSC-Logo3.png"
              clientId="2b5792de-bf7e-4a63-ab30-ee6090c66ad6"
              mintConfig={{
                  type: "erc-721",
                  price: formatEther(coinMaticPrice),
                  amount: desiredCount,
                }}
          /> */}

          <TransactionFlowModal
            price={coinPrice}
            desiredCount={desiredCount}
            executeFn={buyCoin}
            wethAllowance={wethAllowance}
            approveWETHFn={approveWETH}
            open={showCoinModal}
            onClose={() => setShowCoinModal(false)}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
